// A titled result group (Articles / Jurisprudence / Faits / Pièces) — pure
// presentation. The title + count come pre-resolved from the parent pane
// (i18n + interpolated count), so this component does no t() lookup itself:
// it lays out the header + its card children with logical-RTL utilities.

import type { ReactNode } from 'react'

interface SourceGroupProps {
  /** Already-translated group title. */
  title: string
  /** Already-translated, interpolated count line (e.g. "3 résultats"). */
  count: string
  /** Stable test/debug hook for the group. */
  testId: string
  children: ReactNode
}

export function SourceGroup({
  title,
  count,
  testId,
  children,
}: SourceGroupProps): JSX.Element {
  return (
    <section data-testid={testId} className="flex flex-col gap-1.5">
      <div className="flex items-baseline justify-between">
        <h3 className="text-[11px] font-semibold uppercase tracking-wide text-ink/70">
          {title}
        </h3>
        <span className="text-[10px] text-ink/50">{count}</span>
      </div>
      {children}
    </section>
  )
}
